

export default function PrivacyPolicy() {
  return (
    <div className="privacy-policy">
  <h1 className="privacy-policy__main-heading">Privacy Policy</h1>
  <h3 className="privacy-policy__sub-heading">Effective Date: 1/1/2025</h3>

  <h2 className="privacy-policy__sub-heading">1. Introduction</h2>
  <p className="privacy-policy__description">
    Amplify Loyalty LLC (“we,” “our,” or “us”) operates the Amplify Loyalty platform and related websites.
    This privacy policy explains how we collect, use, share, and protect personal information collected
    through our application, website, and associated marketing tools. By using our services, you agree to this policy.
  </p>

  <h2 className="privacy-policy__sub-heading">2. Information We Collect</h2>
  <p className="privacy-policy__description">
    We collect information directly and automatically when you interact with our services.
  </p>
  <ul className="privacy-policy__list">
    <li className="privacy-policy__list-item">
      <strong>Account registration:</strong> Email address, store name, store URL, and password.
    </li>
    <li className="privacy-policy__list-item">
      <strong>Third-party connections:</strong> When you connect accounts such as Shopify, we collect customer-related data
      (names, emails, phone numbers, order totals, and dates).
    </li>
    <li className="privacy-policy__list-item">
      <strong>SMS sign-up:</strong> If you opt in to receive text messages, we collect your phone number and record your
      consent to receive recurring marketing and service-related text messages.
    </li>
    <li className="privacy-policy__list-item">
      <strong>Automatic data collection:</strong> Device information, IP address, browser type, usage data, and activity
      through cookies, pixels, and similar tracking technologies for analytics and advertising.
    </li>
  </ul>
  <p className="privacy-policy__description">
    We also use pixels and tags from Meta (Facebook) Ads, Google Analytics, Klaviyo, and similar services that measure engagement, conversions, and ad performance.
  </p>

  <h2 className="privacy-policy__sub-heading">3. How We Use Your Information</h2>
  <ul className="privacy-policy__list">
    <li className="privacy-policy__list-item">
      <strong>For Merchants:</strong> To manage your account, provide our services, analyze platform usage, improve performance,
      and support marketing and analytics.
    </li>
    <li className="privacy-policy__list-item">
      <strong>For End-Customers:</strong> To display loyalty program data such as points, rewards, and redemption history; deliver
      transactional and promotional communications (including emails and SMS where consented); and prevent fraud.
    </li>
  </ul>
  <p className="privacy-policy__description">
    We do not use merchant customer data for unrelated marketing purposes.
  </p>

  <h2 className="privacy-policy__sub-heading">4. SMS and Email Communications</h2>
  <p className="privacy-policy__description">
    By signing up for text messages, you consent to receive recurring automated promotional and personalized marketing text
    messages from Amplify Loyalty or participating merchants. Message frequency varies. Message and data rates may apply.
    Consent is not a condition of purchase. You may opt out at any time by replying <strong>STOP</strong>, or request help by replying
    <strong> HELP</strong>. We securely store opt-in data (phone number, timestamp, and consent version) for compliance.
  </p>
  <p className="privacy-policy__description">
    We may also send transactional and marketing emails through trusted partners such as Klaviyo.
  </p>
  <p>For more details about our mobile messaging practices, please review our <a href="/mobile-terms">Mobile Terms of Service</a>.</p>

  <h2 className="privacy-policy__sub-heading">5. Sharing Your Information</h2>
  <p className="privacy-policy__description">We may share your information with trusted third parties, including:</p>
  <ul className="privacy-policy__list">
    <li className="privacy-policy__list-item"><strong>Payment Processors:</strong> For secure payment handling.</li>
    <li className="privacy-policy__list-item"><strong>Marketing & Analytics Partners:</strong> Including Meta, Google, and Klaviyo, to measure engagement and ad performance.</li>
    <li className="privacy-policy__list-item"><strong>Service Providers:</strong> That help operate or maintain our platform under confidentiality agreements.</li>
  </ul>
  <p className="privacy-policy__description">We do not sell your personal information.</p>

  <h2 className="privacy-policy__sub-heading">6. Data Storage & Security</h2>
  <ul className="privacy-policy__list">
    <li className="privacy-policy__list-item"><strong>Storage:</strong> Data is stored securely through cloud infrastructure.</li>
    <li className="privacy-policy__list-item"><strong>Security:</strong> We use encryption, access control, and secure transmission methods.</li>
    <li className="privacy-policy__list-item"><strong>Retention:</strong> Active accounts retain data indefinitely. Inactive accounts are deleted after up to two years or upon request.</li>
  </ul>

  <h2 className="privacy-policy__sub-heading">7. Your Rights</h2>
  <ul className="privacy-policy__list">
    <li className="privacy-policy__list-item"><strong>Access & Update:</strong> You may access and update your personal information within the platform.</li>
    <li className="privacy-policy__list-item"><strong>Deletion:</strong> You can request deletion of your data, subject to legal or operational requirements.</li>
    <li className="privacy-policy__list-item"><strong>Opt-Out:</strong> You can opt out of analytics tracking or marketing communications at any time.</li>
    <li className="privacy-policy__list-item"><strong>Policy Changes:</strong> We will notify you of significant updates via email or upon login.</li>
  </ul>

  <h2 className="privacy-policy__sub-heading">8. Cookies, Analytics, and Advertising</h2>
  <p className="privacy-policy__description">
    We use cookies and pixels to personalize content and analyze traffic. These include:
  </p>
  <ul className="privacy-policy__list">
    <li className="privacy-policy__list-item"><strong>Google Analytics:</strong> To understand user behavior and improve functionality.</li>
    <li className="privacy-policy__list-item"><strong>Meta (Facebook) Pixel:</strong> To measure ad performance and conversions.</li>
    <li className="privacy-policy__list-item"><strong>Klaviyo Tracking:</strong> To analyze engagement with marketing emails and web activity.</li>
  </ul>
  <p className="privacy-policy__description">
    You may disable cookies through your browser settings or ad preference tools on Meta and Google.
  </p>

  <h2 className="privacy-policy__sub-heading">9. International Compliance</h2>
  <p className="privacy-policy__description">
    We comply with the California Consumer Privacy Act (CCPA) for California residents and are evaluating GDPR compliance for European users.
    Users in other regions may have similar rights under local privacy laws.
  </p>

  <h2 className="privacy-policy__sub-heading">10. Third-Party Integrations</h2>
  <p className="privacy-policy__description">
    Our platform integrates with services such as Shopify, which may collect and process data when you connect your store.
    These integrations are optional and subject to each third party’s own privacy policy.
  </p>

  <h2 className="privacy-policy__sub-heading">11. Contact Us</h2>
  <p className="privacy-policy__description">
    If you have any questions about this privacy policy or our data practices, please contact us at:
    <a href="mailto:trevor@amplifyloyalty.com"> trevor@amplifyloyalty.com</a>.
  </p>
</div>
  )
}